import { BPReading } from './api';

export async function analyzeReadings(readings: BPReading[], language: string): Promise<string> {
  const prompt = `Analyze the following blood pressure readings and provide insights in ${language}:
${readings.map(reading => 
  `- Date: ${new Date(reading.date).toLocaleDateString()}, 
   Systolic: ${reading.systolic} mmHg, 
   Diastolic: ${reading.diastolic} mmHg, 
   Pulse: ${reading.pulse} bpm, 
   Mood: ${reading.mood}/5${reading.comment ? `, Note: ${reading.comment}` : ''}`
).join('\n')}

Please provide:
1. Overall trend analysis
2. Any concerning patterns
3. General health recommendations
`;

  try {
    const response = await fetch('https://ivanchuyko.com/ai_api/api/generate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prompt }),
    });

    if (!response.ok) {
      throw new Error('Failed to get AI analysis');
    }

    const data = await response.json();
    
    // Extract the text from the response structure
    if (data.candidates && data.candidates[0]?.content?.parts?.[0]?.text) {
      return data.candidates[0].content.parts[0].text;
    }
    
    throw new Error('Invalid response format from AI service');
  } catch (error) {
    console.error('Error getting AI analysis:', error);
    throw error;
  }
} 